import type { LucideIcon } from "lucide-react";
import { Copy, LayoutList, ListChecks, SquarePen } from "lucide-react";

export type QuestionType = "multiple_choice" | "flashcards" | "written";

export type ModeType = "combo" | "multiple_choice" | "written" | "flashcards";

interface Mode {
  value: ModeType;
  icon: LucideIcon;
  label: string;
}

export const MODES: Record<ModeType, Mode> = {
  combo: { value: "combo", icon: ListChecks, label: "Combo" },
  multiple_choice: {
    value: "multiple_choice",
    icon: LayoutList,
    label: "Multiple Choice",
  },
  written: { value: "written", icon: SquarePen, label: "Written" },
  flashcards: { value: "flashcards", icon: Copy, label: "Flashcards" },
} as const;

export const VALID_MODES = Object.keys(MODES) as ModeType[];

export const options = Object.values(MODES);
